// extracted by mini-css-extract-plugin
export default {"headingYellow":"BuyESIMCongratulations_headingYellow__m55Yt"};